import React from 'react';
import { TableBody } from '@mui/material';
import CompletedReviewItem from './CompletedReviewItem';
import { CompletedReviewModel } from '../../lib/models/CompletedReviewModel';

export type CompletedReivewListingProps = {
    data: CompletedReviewModel[];
};

const CompletedReviewListing = ({ data }: CompletedReivewListingProps) => {
    return (
        <TableBody>
            {data.map((item, index) => (
                <CompletedReviewItem key={index} item={item} />
            ))}
        </TableBody>
    );
};

export default CompletedReviewListing;
